(function () {
  'use strict';

  var root = document.documentElement;
  var cartStateClass = 'obfw-cart-drawer-open';
  var dynamicStyleId = 'obfw-dynamic-mobile-header-style';
  var cartApiBound = false;
  var closeTimer = null;
  var styleObserver = null;

  function patchDynamicStyle() {
    var style = document.getElementById(dynamicStyleId);
    if (!style) return false;

    if (style.getAttribute('data-obfw-cart-isolated') === 'true') return true;

    var css = style.textContent || '';
    var patched = css
      .replace(/html\.mm-opened/g, 'html.' + cartStateClass)
      .replace(/html\.mm-opening/g, 'html.' + cartStateClass);

    if (patched !== css) style.textContent = patched;
    style.setAttribute('data-obfw-cart-isolated', 'true');
    return true;
  }

  function ensureStyleIsolation() {
    if (patchDynamicStyle()) {
      if (styleObserver) {
        styleObserver.disconnect();
        styleObserver = null;
      }
      return;
    }

    if (!styleObserver && 'MutationObserver' in window && document.head) {
      styleObserver = new MutationObserver(function () {
        if (patchDynamicStyle()) {
          styleObserver.disconnect();
          styleObserver = null;
        }
      });
      styleObserver.observe(document.head, { childList: true, subtree: true });
    }
  }

  function getCartApi() {
    try {
      if (!window.jQuery) return null;
      var cart = window.jQuery('#cart');
      if (!cart.length) return null;
      return cart.data('mmenu') || null;
    } catch (error) {
      return null;
    }
  }

  function markCartOpen() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
    ensureStyleIsolation();
    root.classList.add(cartStateClass);
  }

  function markCartClosed() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
    root.classList.remove(cartStateClass);
  }

  function bindCartApi() {
    if (cartApiBound) return true;

    var api = getCartApi();
    if (!api || typeof api.bind !== 'function') return false;

    api.bind('opened', markCartOpen);
    api.bind('closed', markCartClosed);
    cartApiBound = true;
    return true;
  }

  function closeCartDrawer(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    var api = getCartApi();

    if (api && typeof api.close === 'function') {
      api.close();
    } else if (window.jQuery) {
      try {
        window.jQuery('#cart').trigger('close.mm');
      } catch (error) {
        // Fallback below clears only our presentation state.
      }
    }

    closeTimer = window.setTimeout(markCartClosed, 450);
  }

  function handleClick(event) {
    if (!event.target || !event.target.closest) return;

    var closeTrigger = event.target.closest('#cart .continue');
    if (closeTrigger) {
      closeCartDrawer(event);
      return;
    }

    var navTrigger = event.target.closest('a[href="#nav"], .icon-menu');
    if (navTrigger) {
      markCartClosed();
      return;
    }

    var cartTrigger = event.target.closest('.cart-button, a[href="#cart"]');
    if (cartTrigger && cartTrigger.matches('[data-partner-cart-trigger]')) {
      return;
    }
    if (cartTrigger && !cartTrigger.closest('#cart')) {
      markCartOpen();
      window.setTimeout(bindCartApi, 0);
      window.setTimeout(bindCartApi, 80);
    }
  }

  function handleKeydown(event) {
    if (event.key !== 'Escape') return;
    if (!root.classList.contains(cartStateClass)) return;

    window.setTimeout(function () {
      var stillOpen = root.classList.contains('mm-opened') || root.classList.contains('mm-opening');
      if (!stillOpen) markCartClosed();
    }, 350);
  }

  ensureStyleIsolation();
  bindCartApi();

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown, true);

  document.addEventListener('DOMContentLoaded', function () {
    ensureStyleIsolation();
    bindCartApi();
  });

  window.addEventListener('load', function () {
    ensureStyleIsolation();
    bindCartApi();
  });

  window.addEventListener('pageshow', function () {
    ensureStyleIsolation();
    bindCartApi();
    if (!root.classList.contains('mm-opened') && !root.classList.contains('mm-opening')) {
      markCartClosed();
    }
  });

  window.setTimeout(function () {
    ensureStyleIsolation();
    bindCartApi();
  }, 50);

  window.setTimeout(function () {
    ensureStyleIsolation();
    bindCartApi();
  }, 250);

  window.setTimeout(function () {
    ensureStyleIsolation();
    bindCartApi();
  }, 750);
})();
